import CommentCustomerIcon from "@assets/images/comment-customer.svg";
import { Button, Grid } from "@material-ui/core";
import CountTextField from "@saleor/components/CountTextField";
import MyTypography from "@saleor/components/MyTypography";
import {
  OrderType,
  RealtimePartnerType,
  useCustomerUnloadingPointsLazyQuery,
  useGet_Realtime_PartnerMutation
} from "@saleor/graphql";
import { getRandomNumber } from "@saleor/utils/getRandowNumber";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { CustomerContext } from "../../CollectionFormSubmit";
import useStyles from "../styles";
import ShippingModal from "./../ModalShipping";
import Address from "./Address";
interface Props {
  address?: any[];
}

export enum ShippingTypeEnum {
  Delivery = "Delivery",
  TaxInvoices = "TaxInvoices",
  Point = "Point"
}

const Shipping: React.FC<Props> = ({ address }) => {
  const classes = useStyles();
  const intl = useIntl();
  const { formik, customerData } = useContext(CustomerContext);
  const [visible, setVisible] = useState<boolean>(false);
  const [shippingType, setShippingType] = useState<ShippingTypeEnum>(
    ShippingTypeEnum.Delivery
  );
  const handleApplyShipping = (value: string) => {
    switch (shippingType) {
      case ShippingTypeEnum.Point:
        return formik.setFieldValue("unloadingPoint", value);
      case ShippingTypeEnum.TaxInvoices:
        return formik.setFieldValue("billTo", value);
      default:
        return formik.setFieldValue("shipTo", value);
    }
  };

  const shippingAddressValue = useMemo(() => formik.values?.shipTo, [
    formik.values?.shipTo
  ]);
  const billingAddressValue = useMemo(() => formik.values?.billTo, [
    formik.values?.billTo
  ]);
  // const pointAddressValue = useMemo(() => formik.values?.unloadingPoint, [
  //   formik.values?.unloadingPoint
  // ]);

  const [
    getRealtimePartnerData,
    { data: realtimePartnerData }
  ] = useGet_Realtime_PartnerMutation({
    variables: {
      type: [RealtimePartnerType.SHIP_TO, RealtimePartnerType.BILL_TO],
      saleOrgCode: "0750",
      soldToCode: customerData?.contract?.soldTo?.code,
      piMessageId: getRandomNumber(),
      distributionChannel: "10",
      division: "00",
      orderType: OrderType.CUSTOMER
    }
  });

  const mappedRealtimePartnerData = useMemo(
    () => realtimePartnerData?.getSapRealtimePartner?.response,
    [realtimePartnerData]
  );

  // const [getShipToData, { data: shipToData }] = useGet_Realtime_PartnerMutation(
  //   {
  //     variables: {
  //       type: RealtimePartnerType.SHIP_TO,
  //       saleOrgCode: "0750",
  //       soldToCode: customerData?.contract?.soldTo?.code,
  //       piMessageId: `${Math.floor(Math.random() * 1000)}`,
  //       distributionChannel: "10",
  //       division: "00",
  //       orderType: OrderType.CUSTOMER
  //     }
  //   }
  // );

  // const [getBillToData, { data: billToData }] = useGet_Realtime_PartnerMutation(
  //   {
  //     variables: {
  //       type: RealtimePartnerType.BILL_TO,
  //       saleOrgCode: "0750",
  //       soldToCode: customerData?.contract?.soldTo?.code,
  //       piMessageId: `${Math.floor(Math.random() * 1000)}`,
  //       distributionChannel: "10",
  //       division: "00",
  //       orderType: OrderType.CUSTOMER
  //     }
  //   }
  // );

  const [
    getUnloadingPointsData,
    { data: unloadingPointsData }
  ] = useCustomerUnloadingPointsLazyQuery({
    variables: {
      soldTo: customerData?.contract?.soldTo?.code
    },
    fetchPolicy: "no-cache"
  });

  const addressOptions = useMemo(() => {
    if (shippingType === ShippingTypeEnum.TaxInvoices) {
      return (
        mappedRealtimePartnerData?.filter(e => e.partnerFunction === "RE") || []
      );
    }
    if (shippingType === ShippingTypeEnum.Point) {
      return unloadingPointsData?.contractUnloadingPoint || [];
    }
    if (shippingType === ShippingTypeEnum.Delivery) {
      return (
        mappedRealtimePartnerData?.filter(e => e.partnerFunction === "WE") || []
      );
    }
    return [];
  }, [shippingType, mappedRealtimePartnerData, unloadingPointsData]);

  useEffect(() => {
    if (visible) {
      if (
        shippingType === ShippingTypeEnum.TaxInvoices ||
        shippingType === ShippingTypeEnum.Delivery
      ) {
        getRealtimePartnerData();
      }
      if (shippingType === ShippingTypeEnum.Point) {
        getUnloadingPointsData();
      }
    }
  }, [visible, shippingType]);

  useEffect(() => {
    if (customerData?.contract) {
      getRealtimePartnerData();
      getUnloadingPointsData();
    }
  }, [customerData]);

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} md={12}>
          <div className={classes.shippingAddress}>
            <MyTypography variant="subtitle3" className={classes.labelAddress}>
              {intl.formatMessage({
                defaultMessage: "ที่อยู่สำหรับออกใบกำกับภาษี",
                description: "label"
              })}
              <span className={classes.required}>*</span>
            </MyTypography>
            {(mappedRealtimePartnerData?.filter(e => e.partnerFunction === "RE")
              ?.length || 0) > 1 ? (
              <Button
                id="editBillingAddressButton"
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => {
                  setVisible(true);
                  setShippingType(ShippingTypeEnum.TaxInvoices);
                }}
                className={classes.btnAddress}
              >
                {intl.formatMessage({
                  defaultMessage: "แก้ไข",
                  description: "label"
                })}
              </Button>
            ) : null}
          </div>
          <Address address={billingAddressValue} />
        </Grid>
        <Grid item xs={12} md={12}>
          <div className={classes.shippingAddress}>
            <MyTypography variant="subtitle3" className={classes.labelAddress}>
              {intl.formatMessage({
                defaultMessage: "สถานที่จัดส่งสินค้า",
                description: "label"
              })}
              <span className={classes.required}>*</span>
            </MyTypography>
            {(mappedRealtimePartnerData?.filter(e => e.partnerFunction === "WE")
              ?.length || 0) > 1 ? (
              <Button
                id="editShippingAddressButton"
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => {
                  setVisible(true);
                  setShippingType(ShippingTypeEnum.Delivery);
                }}
                className={classes.btnAddress}
              >
                {intl.formatMessage({
                  defaultMessage: "แก้ไข",
                  description: "label"
                })}
              </Button>
            ) : null}
          </div>
          <Address address={shippingAddressValue} />
        </Grid>
        <Grid item xs={12} md={12}>
          <CountTextField
            maxLength={250}
            title={
              <>
                <img
                  src={CommentCustomerIcon}
                  alt="Comment"
                  style={{ marginRight: "5px" }}
                />
                <FormattedMessage
                  defaultMessage={"ข้อมูลเพิ่มเติมสำหรับคลังสินค้า"}
                />
              </>
            }
            name="internalCommentsToWarehouse"
            id="internalCommentsToWarehouse"
            value={formik.values.internalCommentsToWarehouse}
            onChange={formik.handleChange}
          />
        </Grid>
      </Grid>
      {visible && (
        <ShippingModal
          visible
          addressOptions={addressOptions}
          onClose={() => setVisible(false)}
          type={shippingType}
          address={address}
          handleApplyShipping={handleApplyShipping}
        />
      )}
    </>
  );
};

export default Shipping;
